<template>
  <ais-clear-refinements
    :class-names="{
      'ais-ClearRefinements-button': 'btn btn-link ps-0',
      'ais-ClearRefinements-button--disabled': 'd-none'
      }"
    :excluded-attributes="['region', 'district', 'query']"
    >
    <template v-slot:resetLabel>Clear all filters <i class="bi bi-x-lg"></i></template>
  </ais-clear-refinements>
</template>

<script>
import { AisClearRefinements } from 'vue-instantsearch/vue3/es';

export default {
  name: 'SearchFilterClear',
  components: {
    AisClearRefinements,
  },
};
</script>
